import { BankServicesQuery } from "@/generated/graphql_billing";
import { ReferenceData } from "@/libs/test/referencedata";
import { graphql, HttpResponse } from "msw";

export const bankServicesDynamicHandler = (
  bankServicesQuery: BankServicesQuery
) => {
  return graphql.query<BankServicesQuery>(
    "bankServices",
    ({ query, variables }) => {
      return HttpResponse.json({ data: bankServicesQuery });
    }
  );
};

export const bankServicesHandler = graphql.query<BankServicesQuery>(
  "bankServices",
  ({ query, variables }) => {
    return HttpResponse.json({ data: ReferenceData.bankServicesQuery });
  }
);
